import React, { useEffect, useState, useCallback } from 'react';
import { Typography, Box } from '@mui/material';
import DashboardStats from './Dashboard/DashboardStats';
import CampaignsOverview from './Dashboard/CampaignOverview';
import DashboardLayout from './DashboardLayout'; 
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PageLoader from '../../../Reusable/PageLoader';
import baseURL from '../config';

const Dashboard = () => {
    const [stats, setStats] = useState({
        user_balance: 0,
        active_campaigns: 0,
        total_raised: 0,
    });
    const [campaigns, setCampaigns] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchDashboardData = useCallback(async () => {
        setLoading(true);
        try {

           // await new Promise(resolve => setTimeout(resolve, 4000));
            // Fetch both stats and campaigns concurrently
            const [statsResponse, campaignsResponse] = await Promise.all([
                fetch(`${baseURL}/user/dashboard-stats`, { credentials: "include" }),
                fetch(`${baseURL}/user/campaigns`, { credentials: "include" })
            ]);

            const [statsData, campaignsData] = await Promise.all([
                statsResponse.json(),
                campaignsResponse.json()
            ]);

            if (!statsResponse.ok) throw new Error(statsData.message || 'Failed to load dashboard statistics.');
            if (!campaignsResponse.ok) throw new Error(campaignsData.message || 'Failed to load campaigns.');

            setStats({
                user_balance: statsData.user_balance || 0,
                active_campaigns: statsData.active_campaigns || 0,
                total_raised: statsData.total_raised || 0,
            });
            setCampaigns(campaignsData || []);
        } catch (err) {
            toast.error(err.message || 'Failed to load dashboard data.');
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchDashboardData();
    }, [fetchDashboardData]);

    return (
        <DashboardLayout>
            {loading && <PageLoader />} {/* Loader inside layout */}

            {!loading && (
                <>
                    <DashboardStats stats={stats} />

                    <Typography
                        variant="h6"
                        sx={{
                            color: '#666',
                            marginBottom: 2,
                            textAlign: 'left',
                            marginTop: 2,
                            fontWeight: '600',
                        }}
                    >
                        Campaigns
                    </Typography>

                    <CampaignsOverview campaigns={campaigns} />
                </>
            )}
        </DashboardLayout>
    );
};

export default Dashboard;
